import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getUser(data) {
    return request.get(`/${platform}/auth/user`, data)
}

export function updatePassword(data) {
    return request.put(`/${platform}/auth/password`, data)
}

export function logout() {
    return request.post(`/${platform}/auth/logout`)
}

export function getUsers(data) {
    return request.get(`/${platform}/users`,data)
}

export function updateUser(data) {
    return request.put(`/${platform}/users/${data.id}`, data)
}

export function updateUserBalance(data) {
    return request.put(`/${platform}/users/${data.id}/balance`, data)
}

export function cancelUser(data) {
    return request.put(`/${platform}/users/${data.id}/cancel`)
}

export function resetUserIp(data) {
    return request.post(`/${platform}/users/${data.id}/reset_ip`)
}

export function userToTest(data) {
    return request.post(`/${platform}/users/${data.id}/test`)
}

export function blockUser(data) {
    return request.post(`/${platform}/users/${data.id}/block`, data)
}

export function getOrders(data) {
    return request.get(`/${platform}/users/${data.id}/orders`,data)
}

export function getSigns(data) {
    return request.get(`/${platform}/users/${data.id}/signs`,data)
}

export function getBills(data) {
    return request.get(`/${platform}/users/${data.id}/bills`,data)
}

export function getScores(data) {
    return request.get(`/${platform}/users/${data.id}/scores`,data)
}

export function getViews(data) {
    return request.get(`/${platform}/users/${data.id}/views`,data)
}

export function getInfo(data) {
    return request.get(`/${platform}/users/${data.id}/show`,data)
}

export function updateEnabled(data) {
    return request.put(`/${platform}/users/${data.id}/enabled`,data)
}

export function switchLogin(data) {
    return request.post(`/${platform}/auth/switch_login`,data)
}
